<template>
  <div class="-home">
    <section-info></section-info>
    <div class="c_main -pad">
      <div class="inner">
        <div class="warp">
          <div class="main">
            <p class="contest-ended" v-if="isShokaiHost">
              コンテストは終了しました。
            </p>
            <home-survey-list :surveys="surveys"></home-survey-list>
            <home-contents-list></home-contents-list>
            <home-referral-ranking v-if="isShokai"></home-referral-ranking>
          </div>
          <div class="side">
            <div class="status">
              <div class="status_prof">
                <figure class="status_prof_img">
                  <img :src="profile.avatar" width="50" height="50" alt />
                </figure>
                <div class="status_prof_cnt">
                  <p class="status_prof_aff">
                    {{ $auth.user.user_metadata.organization_name }}
                  </p>
                  <p class="status_prof_name">
                    <em>
                      {{ $auth.user.email }}
                    </em>
                  </p>
                </div>
              </div>
              <p class="status_msg">
                {{ profile.goal ? profile.goal : "目標未設定" }}
              </p>
              <p class="referred_count" v-if="isShokai">
                紹介人数: {{ profile.referred_count }}人
              </p>
            </div>
            <div class="char">
              <Character ref="character" :char="profile.character"></Character>
            </div>
            <p class="update">
              <a class="c_txtlink -arrow" @click="$modal.show('profile')">
                プロフィール画像を変更する
              </a>
            </p>
            <p class="update">
              <a class="c_txtlink -arrow" @click="$modal.show('goal')">
                目標を変更する
              </a>
            </p>
            <p class="update change-char">
              <a class="c_txtlink -arrow" @click="$modal.show('character')">
                キャラクターを変更する
              </a>
            </p>
            <div>
              <img
                v-if="org && org.ad_image"
                :src="org.ad_image"
                alt=""
                class="ad-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- プロフィール画像設定 -->
    <modal name="profile" adaptive height="auto" width="85%" :maxWidth="780">
      <section id="profile" class="c_popup">
        <h2 class="c_popup_ttl">プロフィール画像を変更する</h2>
        <p class="c_popup_lead">
          プロフィール画像を選択してください。推奨サイズ150×150px
        </p>
        <div class="c_popup_form">
          <input type="file" ref="file" @change="selectFile" />
        </div>
        <div class="c_popup_btns">
          <button class="c_btn" type="button" @click="setProfileImage">
            画像を変更
          </button>
        </div>
      </section>
    </modal>
    <!-- 目標設定 -->
    <modal name="goal" adaptive height="auto" width="85%" :maxWidth="789">
      <section id="goal" class="c_popup">
        <h2 class="c_popup_ttl">目標を変更する</h2>
        <p class="c_popup_lead">
          目標を変更できます。テキスト修正後、「目標を変更」をクリックしてください。推奨：30文字程度
        </p>
        <div class="c_popup_form">
          <input
            type="text"
            placeholder="例: 今秋、長官賞をとる！"
            v-model="newGoal"
          />
        </div>
        <div class="c_popup_btns">
          <button class="c_btn" type="button" @click="setGoal">
            目標を変更
          </button>
          <button class="c_btn -gray" type="button" @click="newGoal = ''">
            クリア
          </button>
        </div>
      </section>
    </modal>
    <!-- キャラクター選択 -->
    <modal name="character" adaptive height="auto" width="85%" :maxWidth="868">
      <section id="character" class="c_popup">
        <h2 class="c_popup_ttl">キャラクターを変更する</h2>
        <p class="c_popup_lead">
          トップやマイページに表示するキャラクターをいつでも変更できます。
        </p>
        <div class="c_popup_char">
          <label class="c_popup_char_item">
            <figure class="c_popup_char_img">
              <img
                src="/img/mypage/img-char01@2x.png"
                width="162"
                height="162"
                alt
              />
            </figure>
            <div class="c_popup_char_neme">JC3ちゃん(おがわ)</div>
            <div class="c_popup_char_input">
              <input
                type="radio"
                name="char"
                value="0"
                v-model="selectCharacter"
              />
            </div>
          </label>
          <label class="c_popup_char_item">
            <figure class="c_popup_char_img">
              <img
                src="/img/mypage/img-char02@2x.png"
                width="162"
                height="162"
                alt
              />
            </figure>
            <div class="c_popup_char_neme">JC3ちゃん(いちご)</div>
            <div class="c_popup_char_input">
              <input
                type="radio"
                name="char"
                value="1"
                v-model="selectCharacter"
              />
            </div>
          </label>
          <label class="c_popup_char_item">
            <figure class="c_popup_char_img">
              <img
                src="/img/mypage/img-char03@2x.png"
                width="162"
                height="162"
                alt
              />
            </figure>
            <div class="c_popup_char_neme">JC3くん(じんぼ)</div>
            <div class="c_popup_char_input">
              <input
                type="radio"
                name="char"
                value="2"
                v-model="selectCharacter"
              />
            </div>
          </label>
          <label class="c_popup_char_item">
            <figure class="c_popup_char_img">
              <img
                src="/img/mypage/img-char04@2x.png"
                width="162"
                height="162"
                alt
              />
            </figure>
            <div class="c_popup_char_neme">JC3くん(あわじ)</div>
            <div class="c_popup_char_input">
              <input
                type="radio"
                name="char"
                value="3"
                v-model="selectCharacter"
              />
            </div>
          </label>
        </div>
        <div class="c_popup_btns">
          <button class="c_btn" type="button" @click="setCharacter">
            このキャラクターで確定
          </button>
        </div>
      </section>
    </modal>
    <!-- 友達紹介 -->
    <modal name="referral" adaptive height="auto" width="85%" :maxWidth="820">
      <section id="profile" class="c_popup">
        <h2 class="c_popup_ttl">友達に紹介する</h2>
        <p style="margin-top: 10px;">
          以下の紹介文を使って友だちに案内しよう！
        </p>
        <pre class="referral-text">{{ referralMessage }}</pre>
        <div class="c_popup_btns">
          <button
            class="c_btn"
            type="button"
            @click="copyReferralMessage"
            :disabled="copied"
          >
            {{ copied ? "コピーしました！" : "紹介文をコピー" }}
          </button>
        </div>
        <table style="margin-top: 20px;">
          <tr>
            <td valign="top" nowrap>※1</td>
            <td style="padding-left: 4px;">
              シールは2026年8月末に紹介で受講した人数を集計後、登録メールアドレスに住所確認のご連絡を差し上げ、郵送いたします。（MAX30枚となります。16名以上ご紹介の場合は、同一デザインが複数届きます。）
            </td>
          </tr>
          <tr>
            <td valign="top" nowrap>※2</td>
            <td style="padding-left: 4px;">
              紹介したお友達が受講すると、その人数がトップページに表示されます。
            </td>
          </tr>
        </table>
      </section>
    </modal>
  </div>
</template>

<script>
import Character from "@/components/Character";
import SectionInfo from "@/components/SectionInfo";
import HomeContentsList from "@/components/HomeContentsList";
import HomeSurveyList from "@/components/HomeSurveyList";
import HomeReferralRanking from "@/components/HomeReferralRanking";
import { globalData } from "@/global";

export default {
  components: {
    Character,
    SectionInfo,
    HomeContentsList,
    HomeSurveyList,
    HomeReferralRanking
  },
  data: () => ({
    loadingContents: false,
    profile: {
      goal: "",
      character: 0,
      avatar: null,
      referral_code: ""
    },
    profileImage: "",
    newGoal: "",
    selectCharacter: 0,
    referralMessage: "",
    copied: false,
    surveys: [],
    completed: false
  }),
  computed: {
    org() {
      return globalData.org;
    },
    isShokaiHost() {
      return window.location.hostname === "shokai.hygiene.jc3-learning.org";
    },
    isShokai() {
      return this.isShokaiHost && this.completed;
    }
  },
  created() {
    // プロフィール
    this.fetchProfile();
    this.$authAxios.get("/api/survey").then(response => {
      this.surveys = response.data.surveys;
      this.completed = response.data.all_required_completed;
    });
  },
  methods: {
    fetchProfile() {
      this.$authAxios
        .get("/api/profile")
        .then(response => {
          this.profile = response.data;
          this.selectCharacter = response.data.character;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.$refs.character.character();
          this.profile.avatar = this.profile.avatar
            ? this.profile.avatar
            : "/img/cmn/img-profile.jpg";
        });
    },
    setCharacter() {
      let form = { character: this.selectCharacter };
      this.$authAxios
        .patch("/api/profile", form)
        .then(response => {
          this.profile = response.data;
          this.$modal.hide("character");
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.$refs.character.character();
        });
    },
    setGoal() {
      let form = { goal: this.newGoal };
      this.$authAxios
        .patch("/api/profile", form)
        .then(response => {
          this.profile = response.data;
          this.$modal.hide("goal");
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectFile() {
      this.selectedFile = this.$refs.file.files[0];
    },
    setProfileImage() {
      let formData = new FormData();
      formData.append("avatar", this.selectedFile);
      this.$authAxios
        .patch("/api/profile", formData, {})
        .then(response => {
          this.profile = response.data;
          this.$modal.hide("profile");
        })
        .catch(error => {
          console.log(error);
        });
    },
    async openReferralDialog() {
      this.copied = false;
      try {
        if (!this.profile.referral_code) {
          const res = await this.$authAxios.post("/api/referral-code");
          this.profile.referral_code = res.data.referral_code;
        }
        const targetUrl = this.org?.referral_url || window.location.origin;
        this.referralMessage =
          `サイバー防犯ボランティアの活動として、サイバーセキュリティの研修（20分の動画の視聴）を広めるコンテストに参加しています。\n` +
          `大切なあなたにも是非視聴してほしいと思い、紹介させてください。\n` +
          `\n` +
          `▼アクセスはこちら\n` +
          `${targetUrl}\n` +
          `\n` +
          `最初に私の「紹介者コード」を入力してください。\n` +
          `私の紹介者コード: ${this.profile.referral_code}\n` +
          `\n` +
          `この研修は、サイバーセキュリティって難しそう、自分には関係ない、と思っている人向けに作られた動画でして、基本のキがぎゅっと圧縮されています。\n` +
          `気軽に見ていただけると嬉しいです。`;
        this.$modal.show("referral");
      } catch (e) {
        console.error(e);
      }
    },
    copyReferralMessage() {
      navigator.clipboard
        .writeText(this.referralMessage)
        .then(() => (this.copied = true));
    }
  }
};
</script>

<style scoped>
@import "~@/css/home.css";

.update {
  text-align: right;
  margin-top: 10px;
}

.ad-image {
  width: 260px;
  margin-top: 10px;
}

.referral-text {
  background: #f9f9f9;
  padding: 1em;
  border-radius: 4px;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  margin-top: 10px;
  border: solid;
}

/* コンテスト終了のお知らせ */
.contest-ended {
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  background: #f5f5f5;
  color: #333;
  text-align: center;
  font-weight: bold;
}

/* 友達紹介 */
.referral-banner {
  display: block;
  width: 100%;
  background: linear-gradient(135deg, #ff512f, #dd2476); /* 強めの赤オレンジ */
  color: #fff;
  border: none;
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}
.referral-banner:hover {
  transform: scale(1.02);
}
.banner-content h2,
.banner-content p {
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); /* 白文字を見やすく */
}
.banner-content h2 {
  font-size: 1.6em;
  margin-bottom: 12px;
}
.banner-content p {
  margin: 4px 0;
}
.cta-button {
  margin-top: 16px;
  display: inline-block;
  padding: 12px 24px;
  background: #fff; /* 白背景でコントラスト */
  color: #ff512f; /* バナーの色とリンク */
  border-radius: 8px;
  font-weight: bold;
  font-size: 1.2em;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: background 0.2s, color 0.2s;
}
.cta-button:hover {
  background: #ffe3db;
  color: #dd2476;
}

/* add */
.banner-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px; /* テキストとボタンの間隔 */
  margin-top: 16px;
  flex-wrap: wrap; /* 狭い画面では折り返す */
}

.banner-text {
  flex: 1; /* 余白を使ってボタンを右に押す */
  text-align: center;
  font-size: 16px;
}

.banner-text p {
  margin: 4px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.cta-button {
  flex-shrink: 0; /* ボタンが小さく潰れないように */
  text-align: center;
  padding: 12px 24px;
  background: #fff;
  color: #ff512f;
  border-radius: 8px;
  font-weight: bold;
  font-size: 1.2em;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: background 0.2s, color 0.2s;
}

.cta-button:hover {
  background: #ffe3db;
  color: #dd2476;
}

.banner-title {
  font-weight: bold;
}

.referred_count {
  margin-top: 20px;
  font-size: 14px;
  font-weight: bold;
}

.-mobile .banner-row {
  flex-direction: column; /* 縦並びに */
  gap: 12px;
}

.-mobile .banner-text {
  text-align: center; /* モバイル時も中央寄せ */
}

.-mobile .cta-button {
  width: 100%; /* モバイル時は横幅いっぱい */
  max-width: 280px; /* でも大きすぎないよう制限 */
  margin: 0 auto;
}

.-mobile .char {
  display: none;
}

.-mobile .change-char {
  display: none;
}

.c_popup {
  padding-top: 40px;
  padding-bottom: 40px;
}
</style>
